import { BlockCategory } from 'flow-schema';

export const BLOCK_CATEGORY_NAMES: Record<BlockCategory, string> = {
  [BlockCategory.Start]: 'Start',
  [BlockCategory.Logic]: 'Logic',
  [BlockCategory.Data]: 'Data',
  [BlockCategory.Experience]: 'Experience',
  [BlockCategory.Integration]: 'Integration',
  [BlockCategory.Ai]: 'AI',
  [BlockCategory.Export]: 'Export',
  [BlockCategory.Skill]: 'Skill',
  [BlockCategory.Obsolete]: 'Obsolete',
  [BlockCategory.Placeholder]: 'Placeholder',
};
